import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ErrorScreen from '../components/ErrorScreen';
import { routeForRole } from '../utils/roleRoute';

/**
 * 404 de l'app. Remplace l'ancienne redirection silencieuse vers `/`, qui renvoyait
 * sur le splash sans rien dire d'un lien cassé ou mal recopié.
 *
 * Après un rechargement direct sur une URL inconnue, la session n'est pas encore
 * restaurée (c'est le rôle du splash) : `user` est vide et le bouton repasse par `/`,
 * qui restaure la session puis aiguille selon le rôle.
 */
const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <ErrorScreen
      code="404"
      title="Page introuvable"
      message="Cette page n'existe pas ou a été déplacée. Vérifie le lien, ou repars de l'accueil."
      primaryAction={{
        label: "Retour à l'accueil",
        onClick: () => navigate(user ? routeForRole(user.role) : '/', { replace: true }),
      }}
    />
  );
};

export default NotFound;
